import React, { useEffect, useState } from 'react'
import { MdKeyboardArrowUp, MdKeyboardArrowDown, MdOutlineArrowForwardIos } from 'react-icons/md';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { BackNavigation } from '../components/shared';
import { ITabs, Tabs } from '../components/tabs';
import { AppPage } from '../layouts/types';
import ITask from '../models/Task';
import TaskService from '../services/TaskService';
import { RootState, AppDispatch } from '../store';
import { getAllTasks } from '../store/reducers/tasks';
import formatDateToDefault from '../utils/formatDate';

const Screen = ({ data }: { data: ITask[] }) => {
  console.log('data: ', data);

  const [tasksx, setTasks] = useState<ITask[]>([]);
  const [sortByDueDate, setSortByDueDate] = useState<"asc" | "desc">("asc");
  const { tasks } = useSelector((state: RootState) => state.tasks);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getAllTasks());
  }, []);

  // Function to sort tasks by due date
  const sortTasksByDueDate = () => {
    const sortedTasks = [...tasks]; // Create a copy of the tasks array

    sortedTasks.sort((a, b) => {
      const dueDateA = a.dueDate && isValidDate(a.dueDate) ? new Date(a.dueDate).getTime() : Infinity;
      const dueDateB = b.dueDate && isValidDate(b.dueDate) ? new Date(b.dueDate).getTime() : Infinity;
      return sortByDueDate === "asc" ? dueDateA - dueDateB : dueDateB - dueDateA;
    });

    setTasks(sortedTasks);
  };

  // Add isValidDate helper
  const isValidDate = (date: any): boolean => {
    if (!date || date === "") return false;
    const parsedDate = new Date(date);
    return !isNaN(parsedDate.getTime());
  };

  console.log("taskss", tasks);

  return (
    <>
      <div className="flex tablet:hidden mobile:hidden">
        <table className="min-w-full font-normal text-app-gray-medium text-xs table-fixed">
          <thead>
            <tr className="text-left justify-between gap-2">
              <th className="w-1"></th>
              <th className="w-32 px-4">Task Title</th>
              <th className="w-20 px-4">Task Category</th>
              <th className="w-16 px-4">Task Type</th>
              <th className="w-16 px-4">Session</th>
              <th className="w-16 px-4">Programme</th>
              <th className="w-32 px-4">
                <p
                  className="justify-items-center flex items-center cursor-pointer whitespace-nowrap"
                  onClick={() => {
                    setSortByDueDate(sortByDueDate === "asc" ? "desc" : "asc");
                    sortTasksByDueDate();
                  }}
                >
                  Due Date
                  <span className="text-zinc-500 ml-1 font-extrabold text-[24px]">
                    {sortByDueDate === "asc" ? (
                      <MdKeyboardArrowUp />
                    ) : (
                      <MdKeyboardArrowDown />
                    )}
                  </span>
                </p>
              </th>
              <th className="w-4"></th>
            </tr>
          </thead>
          <tbody>
            {data.map((el) => (
              <tr
                className="h-14 text-xs hover:bg-app-purple shadow-sm rounded divide-y-8 divide-app-purple-100 mb-5"
                key={el.id + Math.random() * 1000}
              >
                <td className="w-1"></td>
                <td className="w-32 px-4 bg-white font-bold whitespace-normal">
                  {el.title}
                </td>
                <td className="w-20 px-4 bg-white whitespace-normal">
                  {el.category === "pre"
                    ? "Pre-Work"
                    : el.category === "post"
                      ? "Post-Work"
                      : "Other"}
                </td>
                <td className="w-16 px-4 bg-white whitespace-normal">
                  {el.type === "Assessment"
                    ? el.type + "-" + el.assessmentType
                    : el.type}
                </td>
                <td className="w-16 px-4 bg-white whitespace-normal">
                  {el?.session?.name}
                </td>
                <td className="w-32 px-4 bg-white max-w-sm whitespace-normal">
                  <div className="max-w-md truncate">
                    {el?.programName}
                  </div>
                </td>
                <td className="w-32 px-4 bg-white whitespace-normal">
                  {formatDateToDefault(el.dueDate)}
                </td>
                <td className="w-4 px-4 bg-white font-bold whitespace-normal">
                  <div className="flex flex-row items-center justify-end text-sm font-semibold">
                    {/* {el.isCompleted ? (
                      <span className="text-green-400">
                        {el.redo ? `Re-do ${el.type}` : "Completed"}
                      </span>
                    ) : (
                      <>
                        <Link
                          to={`/task/${el.id}`}
                          className="underline text-purple-900"
                        >
                          Complete
                        </Link>
                        <MdOutlineArrowForwardIos />
                      </>
                    )} */}
                    {el.isCompleted ? (
                      <span className="text-green-400">
                        {el.redo ? `Re-do ${el.type}` : "Completed"}
                      </span>
                    ) : !el.ongoing ? (
                      <span className="text-gray-400 cursor-not-allowed">
                        Closed
                      </span>
                    ) : (
                      <>
                        <Link
                          to={`/task/${el.id}`}
                          className="underline text-purple-900"
                        >
                          Complete
                        </Link>
                        <MdOutlineArrowForwardIos />
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="hidden mobile:grid mobile:grid-cols-1 tablet:grid tablet:grid-cols-2 justify-between text-app-gray-medium gap-4">
        {data.map((el) => (
          <div
            className="bg-white shadow-md rounded-md p-4 grid grid-cols-2 gap-4"
            key={el.id}
          >
            <div className="col-span-2">
              <div className="col-span-2">
                <h2 className="font-bold">{el.title}</h2>
              </div>
              <div className="flex flex-row justify-stretch">
                <span className="font-semibold w-1/2">Task Type</span>
                <span className="w-1/2">
                  :&nbsp;
                  {el.category === "pre"
                    ? "Pre-Work"
                    : el.category === "post"
                      ? "Post-Work"
                      : "Other"}
                </span>
              </div>
              <div className="flex flex-row justify-between">
                <span className="font-semibold w-1/2">Session</span>
                <span className="w-1/2">:&nbsp;{el?.session?.name}</span>
              </div>
              <div className="flex flex-row justify-between">
                <span className="font-semibold w-1/2">Programme</span>
                <span className="w-1/2 overflow-x-hidden truncate">
                  :&nbsp;{el?.programName}
                </span>
              </div>
              <div className="flex flex-row justify-between">
                <span className="font-semibold w-1/2">Due Date</span>
                <span className="w-1/2">
                  :&nbsp;{formatDateToDefault(el.dueDate)}
                </span>
              </div>
              <div className="flex flex-row items-center justify-end text-sm font-semibold mt-1">
                {/* {el.isCompleted ? (
                  <span className="text-green-400">
                    {el.redo ? `Re-do ${el.type}` : "Completed"}
                  </span>
                ) : (
                  <>
                    <Link
                      to={`/task/${el.id}`}
                      className="underline text-purple-900"
                    >
                      Complete
                    </Link>
                    <MdOutlineArrowForwardIos />
                  </>
                )} */}
                {el.isCompleted ? (
                  <span className="text-green-400">
                    {el.redo ? `Re-do ${el.type}` : "Completed"}
                  </span>
                ) : !el.ongoing ? (
                  <span className="text-gray-400 cursor-not-allowed">
                    Closed
                  </span>
                ) : (
                  <>
                    <Link
                      to={`/task/${el.id}`}
                      className="underline text-purple-900"
                    >
                      Complete
                    </Link>
                    <MdOutlineArrowForwardIos />
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

const TaskList: AppPage = () => {

  const taskService = new TaskService()
  const [tabData, setTabData] = useState<ITabs | null>(null);

  useEffect(() => {
    taskService.getAllTasks().then((tasks) => {
      console.log('tasks: ', tasks);

      let data: ITabs = {
        Pending: [
          {
            id: 2,
            TabContent: (
              <Screen data={tasks.filter((el) => el.isCompleted === 0)}></Screen>
            ),
          },
        ],
        All: [
          {
            id: 3,
            TabContent: (
              <Screen data={tasks}></Screen>
            ),
          },
        ],
      };
      setTabData(data);
    });
  }, []);

  return (
    <div className="h-full">
      <BackNavigation title="Task List" />
      {!tabData && (
        <div className="h-full animate-bounce w-full flex text-xl justify-center items-center">
          Please wait while fetching your task list .....
        </div>
      )}
      {tabData && <Tabs data={tabData}></Tabs>}
    </div>
  );
};

export default TaskList;